import React from 'react'
import './SidebarOption.css'
import { useNavigate } from 'react-router-dom'
import db from './firebase'
import { useParams } from 'react-router-dom'

function SidebarOption({Icon, title, id, addChannelOption, removeChannelOption, noClick}) {

const navigate = useNavigate()
const { roomId } = useParams()

const selectChannel = () => {
  if (id) {
      navigate(`/room/${id}`)
  } else if (noClick == false) {
    navigate(title)
  } 
}


const addChannel = () => {
const channelName = prompt('Please enter the new channel name:')
if (channelName) {
  // import the db, go to the collection 'rooms', then add a document with the name, channelName
  db.collection("rooms").add({
    name: channelName
  })}
}

const removeChannel = () => {
  const channelName = prompt('Please enter the *exact* name of the channel to be removed (not including  "# ")')
  db.collection('rooms').where('name', '==', channelName).get()
  .then(querySnapshot => {
      querySnapshot.docs[0].ref.delete()
  })
  .catch(() => {
    alert('That name does not match an active channel.')
  })
}

  return (
    <div className='sidebarOption' onClick={
      addChannelOption 
      ? addChannel 
      : removeChannelOption 
        ? removeChannel
        : selectChannel}>



       {Icon && <Icon className='sidebarOption__icon' />}
        {/* if no icon is passed in, add a # and assume it is a thread */}
       {Icon ? <h3 className='sidebarOption__channel'>{title}</h3> : <h3> <span className='sidebarOption__hash'>#</span> {title}</h3>}

        </div>
  )
}

export default SidebarOption